// vouched-script.js

export function loadVouched(
  {
    publicKey,
    firstName,
    lastName,
    email,
    callbackURL,
    reverificationJobId,
    onInit,
    onDone,
  },
  vouchedRef,
) {
  // Get computed styles for theming
  const rootStyles = getComputedStyle(document.documentElement);
  const primaryBg = rootStyles
    .getPropertyValue("--inside-primary-button-background")
    .trim();
  const bgColor = rootStyles.getPropertyValue("--background").trim();
  const divBg = rootStyles.getPropertyValue("--div-background").trim();
  const fontClr = rootStyles.getPropertyValue("--inside-div-text-color").trim();
  const buttonFontClr = rootStyles
    .getPropertyValue("--inside-primary-button-text-color")
    .trim();
  const highlightClr = rootStyles
    .getPropertyValue("--inside-highlight-color")
    .trim();
  const divBorderRadius = rootStyles
    .getPropertyValue("--div-border-radius")
    .trim();
  const divShadow = rootStyles.getPropertyValue("--div-shadow-border").trim();

  const themeConfig = {
    theme: {
      name: "verbose",
      baseColor: primaryBg,
      fontColor: fontClr,
      bgColor: bgColor,
      handoffLinkColor: highlightClr,
      iconLabelColor: fontClr,
      iconColor: fontClr,
      navigationActiveText: fontClr,
      navigationDisabledText: fontClr,
      common: {
        container: {
          styles: {
            padding: "0.75rem 1rem",
            borderRadius: divBorderRadius,
            backgroundColor: divBg,
            color: fontClr,
            boxShadow: divShadow,
          },
        },
        layout: {
          header: { styles: { color: fontClr } },
          body: { styles: { color: fontClr, backgroundColor: divBg } },
          footer: { styles: { color: fontClr } },
        },
        headings: { styles: { color: fontClr } },
        buttons: {
          styles: { backgroundColor: primaryBg, color: buttonFontClr },
        },
        inputs: { styles: { color: fontClr, backgroundColor: divBg } },
      },
    },
    handoffView: {
      styles: {
        title: { color: fontClr },
        description: { color: fontClr },
        button: { backgroundColor: primaryBg, color: buttonFontClr },
        optionCard: {
          backgroundColor: divBg,
          borderRadius: divBorderRadius,
          boxShadow: divShadow,
          color: fontClr,
        },
      },
    },
  };

  const config = {
    appId: publicKey,
    callbackURL:
      callbackURL ||
      "https://api.blox.services/vouched_notifications/id_verification_status",
    verification: {
      lastName,
    },
    crossCheck: true,
    crossDevice: true,
    crossDeviceQRCode: true,
    crossDeviceSMS: true,
    liveness: "enhanced",
    id: "both",
    includeBarcode: "true",
    faceMatch: true,
    manualCaptureTimeout: 15000,
    properties: {
      email: email || "",
    },
    userConfirmation: {
      confirmData: true,
      confirmImages: true,
    },
    onInit,
    onDone,
    theme: themeConfig.theme,
    handoffView: themeConfig.handoffView,
  };

  if (reverificationJobId) {
    config.reverification = reverificationJobId;
  }

  const existingScript = document.getElementById("vouched");
  if (!existingScript) {
    const script = document.createElement("script");
    script.src = "https://static.vouched.id/plugin/releases/latest/index.js";
    script.id = "vouched";
    script.async = true;
    document.head.appendChild(script);
    script.onload = () => {
      vouchedRef.current = window.Vouched({ ...config });
      console.log("mount vouched-element");
      vouchedRef.current.mount("#vouched-element");
    };
  }
}

export function unloadVouched(vouchedRef) {
  const existingScript = document.getElementById("vouched");
  if (existingScript && vouchedRef.current) {
    console.log("unmount vouched-element");
    vouchedRef.current.unmount("#vouched-element");
  }
}
